import { Autocomplete, Avatar, Icon, Thumbnail } from '@shopify/polaris';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import __ from 'languages/index';

import { SearchIcon } from '@shopify/polaris-icons';
import helpers from 'helpers/index';
import __helpers from 'helpers/index';
import { TypedWalletCode, useGetWalletCodes } from 'queries/wallet_code.query';

type TypedSearchWalletCode = {
  current_wallet_code_id?: bigint | string /** vô dụng, không hoạt động ... */;
  onClose?: (val: TypedWalletCode) => void;
  title: string;
  placeholder?: string;
  disabled?: boolean;
};

/**
 *
 * @param current_wallet_code_id bigint
 * @param  onClose callback with bigint userid
 * @returns
 */
export default function QuickSearchWalletCode({
  disabled,
  current_wallet_code_id = null,
  onClose,
  title,
  placeholder = 'Tìm một mã wallet code',
}: TypedSearchWalletCode) {
  /**!SECTION
   * Select người handler
   */

  const [mainQuery, setMainQuery] = useState({
    query: '',
    sort: 'createdAt:desc',
    is_cloned: 0,
    is_used: 0,
    limit: 5,
  });

  const { refetch: searchVoucher, isPending: userLoading, data } = useGetWalletCodes(mainQuery);

  /**
   * User list
   */
  const [entities, setEntities] = useState<TypedWalletCode[]>([]);
  /**
   */
  const [userSelected, setUserSelected] = useState<string[]>([]);
  const [userQuickSearchText, setUserQuickSearchText] = useState<string>('');
  const [userListForQuickOption, setUserListForQuickOption] = useState([]);
  useEffect(() => {
    if (data) {
      const { entities } = data;
      setEntities(entities); // bồi thêm data vào cái cũ
    }
  }, [data]);

  const onQueryToServer = useCallback(async () => {
    return await searchVoucher();
  }, []);

  useEffect(() => {
    let innerUser = [];
    if (entities)
      for (let voucher of entities) {
        innerUser.push({
          value: voucher.wallet_code_id,
          label: voucher.wallet_code_name,
        });

        if (current_wallet_code_id && String(voucher.wallet_code_id) === String(current_wallet_code_id)) {
          setUserQuickSearchText(voucher.wallet_code_name);
        }
      }
    setUserListForQuickOption(innerUser);
  }, [entities, current_wallet_code_id]);

  const onChangeMainQueryCallback = useMemo(() => {
    return helpers.debounce((_value: string) => {
      onQueryToServer?.call(this, _value);
    }, 400);
  }, []);

  const updateUserText = useCallback((value: string) => {
    setMainQuery((prevQuery) => ({
      ...prevQuery,
      query: value,
    }));

    setUserQuickSearchText(value);
    onChangeMainQueryCallback(value);
  }, []);

  const findUserSelectedInEntities = useCallback(
    (wallet_code_id) => {
      if (Array.isArray(entities)) {
        let a = entities.filter((a) => a.wallet_code_id === wallet_code_id);
        return a[0] || null;
      }
    },
    [entities]
  );

  const updateSelection = useCallback(
    (selected: string[]) => {
      const selectedValue = selected.map((selectedItem) => {
        const matchedOption = userListForQuickOption.find((option) => {
          return option.value.match(selectedItem);
        });
        return matchedOption && matchedOption.label;
      });
      setUserSelected(selected);
      setUserQuickSearchText(selectedValue[0] || '');
      // @ts-ignore
      onClose?.call(this, findUserSelectedInEntities(selected[0]));
    },
    [userListForQuickOption]
  );

  useEffect(() => {
    onChangeMainQueryCallback('');
  }, []);

  const textFieldSelectUser = (
    <>
      <Autocomplete.TextField
        align="left"
        onChange={updateUserText}
        label={title}
        disabled={disabled}
        value={userQuickSearchText}
        prefix={<Icon source={SearchIcon} tone="base" />}
        placeholder={placeholder}
        autoComplete="off"
      />
    </>
  );

  return (
    <>
      <Autocomplete
        options={userListForQuickOption}
        selected={userSelected}
        onSelect={updateSelection}
        textField={textFieldSelectUser}
        loading={userLoading}
        id="quickSearchVoucherModalPopover"
      />
    </>
  );
}

